module.exports = __webpack_public_path__ + "img/home_button.9ba9e20a.png";